import { TimeDelayNodeData } from "pages/FlowBuilderv2/Nodes/NodeData";
import React, { FC } from "react";
import TimeDelayEditor from "../components/TimeDelayEditor";
import { SidePanelComponentProps } from "../FlowBuilderSidePanel";
import { useSidePanelReadOnly } from "../SidePanelReadOnlyContext";

const TimeDelaySettings: FC<SidePanelComponentProps<TimeDelayNodeData>> = ({
  nodeData,
  setNodeData,
}) => {
  const readOnly = useSidePanelReadOnly();
  return (
    <div
      className={`flex flex-col gap-2${
        readOnly ? " pointer-events-none select-none" : ""
      }`}
    >
      <TimeDelayEditor
        delay={nodeData.delay}
        onChange={(delay) => setNodeData({ ...nodeData, delay })}
      />
      <div className="text-[12px] text-themed-textSecondary">
        Contacts move forward on the next workflow tick after this delay is
        reached, so a zero-minute delay can still wait for the next tick.
      </div>
    </div>
  );
};

export default TimeDelaySettings;
